
import Banner from './banner/Banner'
import Header from '../../ui/includes/Header'
import About from './About'
import Expertise from './Expertise'
import Projects from './Projects'
import Services from './Services'
import Certificates from './Certificates'
import Team from './Team'
// import Services from './services/Services'
// import WhyChoose from './whyChoose/WhyChoose'
// import Clients from './clients/Clients'
import Contact from './contact/Contact'
import Footer from '../footer/Footer'
// import WhatsappFloating from '../../Languages/WhatsappFloat'
// import Transform from './ceo/CeoMessage'
// import Projects from './projects/Projects'
// import Faqs from './faqs/Faqs'
// import Contact from './contact/Contact'
// import Footer from '../footer/Footer'



const Index = () => {
    return (
        <>
            <Header />
            <Banner />
            <About />
            <Expertise />
            <Projects />
            <Services />
            <Certificates />
            <Team />
            {/* 
            <WhyChoose />
            <Clients /> */}
            <Contact />
            <Footer />
            {/* <WhatsappFloating /> */}
        </>
    )
}

export default Index
